<template>
    <div>
        <b-form>
            <FormulateInput
                v-model="formValues"
                class="mt-3"
                label="Transportation Details"
                name="transDetails"
                type="group"
                validation="^required"
            >
                <b-row>
                    <b-col md="6">
                        <FormulateInput
                            type="date"
                            name="startDate"
                            label="Start Date"
                            v-model="startDate"
                            help="Sample date help text sample sample sample"
                            validation-name="Start date"
                            :min="today()"
                            :validation="[
                                ['^required'],
                                ['afterToday']
                            ]"
                            :validation-rules="{
                                afterToday: ({ value }) => new Date(value) >= new Date(),
                            }"
                            :validation-messages="{
                                afterToday:`Start date should later than today`,
                            }"
                        />
                    </b-col>
                    <b-col md="6" v-if="isBetweenSummer()">
                        <FormulateInput
                            type="date"
                            name="endDate"
                            label="End Date"
                            validation-name="End Date"
                            help="Only for summer transportation."
                            :min="startDate ? startDate :  today()"
                            :validation="[
                                ['afterStartDate'],
                            ]"
                            :validation-rules="{
                                afterStartDate: ({ value }) => new Date(value) > new Date(startDate)
                            }"
                            :validation-messages="{
                                afterStartDate:`End date should be later than start date.`,
                            }"
                        />
                    </b-col>
                    <b-col md="12" class="mt-3">
                        <h6>School or Program Name</h6>
                        <v-select :options="schoolList" label="name" taggable v-model="selectedSchool" @input="setSchool" placeholder="Please select or type in your school or program name."></v-select>
                        <FormulateInput type="hidden" name="schoolCode" v-model="schoolCode"/>
                        <FormulateInput type="hidden" name="schoolName" v-model="schoolName"/>

                    </b-col>
                </b-row>
                <b-row>
                    <FormulateInput
                    v-if="selectedSchool && schoolList && !schoolList.map(a => a.name).includes(selectedSchool.name)"
                    name="schoolAddress"
                    v-model="schoolAddress"
                    type="hidden"
                /></b-row>
                <b-row>
                    <b-col><student-address
                    v-if="selectedSchool && schoolList && !schoolList.map(a => a.name).includes(selectedSchool.name)"
                    name="schoolAddress"
                    label="School Address"
                    /></b-col>
                </b-row>
                <b-form-group class="mt-3"
                    label="Transportation Time and Day"
                >   
                    <b-row>
                        <b-col md="12">
                            <FormulateInput
                                v-model="inboundDays"
                                :options="weekDays"
                                type="hidden"
                                :multiple="true"
                                label="Select INbound transportation days (TO the school/facility)?"
                                name="inboundDays"
                                help="If the student follows a complicated hybrid scenario (like alternating weeks), please check OTHER and explain."
                            />
                        </b-col>
                        <b-col md="12">
                            <b-form-checkbox v-model="allInDaysSelected" @change="toggleAllInbound" inline> 
                                {{ allInDaysSelected ? 'Un-select All' : 'Select All' }}
                            </b-form-checkbox>
                            <b-form-checkbox-group
                                id="inboundDays"
                                v-model="inboundDays"
                                :options="weekDays"
                                name="inboundDays"
                                @change=checkInboundSelectAll
                                style="display:inline">
                            </b-form-checkbox-group>
                        </b-col>
                        <b-col md="6">
                            <FormulateInput
                                name="startTime"
                                v-if="inboundDays ? inboundDays.length > 0 : false"
                                type="time"
                                v-model="startTime"
                                label="School or Program Start Time"
                                help="Sample time help text"
                                validation="^required"
                                @change="minutesOff('inbound', -10)"
                            />
                        </b-col>
                        <b-col md="6">
                            <FormulateInput
                                name="arrivalTime"
                                v-if="inboundDays ? inboundDays.length > 0 : false"
                                type="time"
                                label="Intended Arrival Time"
                                placeholder="Sample time placeholder"
                                v-model="arrivalTime"
                                help="Default to arrive 10 minutes prior to the start time."
                                :validation="[
                                    ['^required'],
                                    ['beforeStartTime']
                                ]"
                                :validation-rules="{ beforeStartTime: ({ value }) => this.getUnixTime(value) < this.getUnixTime(this.startTime) }"
                                :validation-messages="{
                                    beforeStartTime:`Arrival time should before school or program start time`,
                                }"
                            />
                        </b-col>
                        <b-col md="12">
                            <FormulateInput
                                v-if="inboundDays ? inboundDays.indexOf('Other') > -1 : false"
                                name="inboundOther"
                                label="Please describe your inbound transportation routine here."
                            />
                        </b-col>
                        <b-col md="12" class="mt-3">
                            <FormulateInput
                                type=checkbox
                                name="diffPickupAddress"
                                label="Check here if the pick-up address (home to school/facility) different from the home address."
                            />
                            <student-address 
                                name="newPickupAddress" 
                                label="New Pick Up Address" v-if="this.formValues[0] && this.formValues[0].diffPickupAddress" />
                        </b-col>
                        
                        <b-col md="12" class="mt-3">
                            <FormulateInput
                                type="textarea"
                                name="inboundInfo"
                                label="Specific Dropoff Information for INbound Route (TO school/facility)"
                                help="e.g. DROPOFF DOOR at school/facility."
                            />
                        </b-col>
                    </b-row>
                    <b-row class="mt-4">
                        <b-col md="12">
                            <FormulateInput
                                v-model="outboundDays"
                                :options="weekDays"
                                type="hidden"
                                label="Select OUTbound transportation days (FROM the school/facility)?"
                                name="outboundDays"
                                validation-name="Outbound days"
                                :multiple="true"
                                :validation="[
                                    ['atLeastOneDay'],
                                ]"
                                :validation-rules="{
                                    atLeastOneDay: () => (inboundDays && inboundDays.length )|| (outboundDays && outboundDays.length)
                                }"
                                :validation-messages="{
                                    atLeastOneDay: `At least one transportation day needed`
                                }"
                                help="If the student follows a complicated hybrid scenario (like alternating weeks), please check OTHER and explain."
                            />
                        </b-col>
                        <b-col md="12">
                            <b-form-checkbox v-model="allOutDaysSelected" @change="toggleAllOutbound" inline> 
                                {{ allOutDaysSelected ? 'Un-select All' : 'Select All' }}
                            </b-form-checkbox>
                            <b-form-checkbox-group
                                id="outboundDays"
                                v-model="outboundDays"
                                :options="weekDays"
                                name="outboundDays"
                                @change=checkOutboundSelectAll
                                style="display:inline">
                            </b-form-checkbox-group>
                        </b-col>
                        <b-col md="6">
                            <FormulateInput
                                v-if="outboundDays ? outboundDays.length > 0 : false"
                                type="time"
                                name="schoolEndTime"
                                v-model="schoolEndTime"
                                @change="minutesOff('outbound', 10)"
                                label="School or Program End Time"
                                placeholder="Sample time placeholder"
                                help="Sample time help text"
                                validation="^required"
                            />
                        </b-col>
                        <b-col md="6">
                            <FormulateInput
                                v-if="outboundDays ? outboundDays.length > 0 : false"
                                type="time"
                                name="departureTime"
                                label="Intended Departure Time"
                                placeholder="Sample time placeholder"
                                v-model="departureTime"
                                help="Default to depart 5 minutes after the school or program release time."
                                :validation="[
                                    ['^required'],
                                    ['afterEndTime']
                                ]"
                                :validation-rules="{ afterEndTime: ({ value }) => this.getUnixTime(value) > this.getUnixTime(this.schoolEndTime) }"
                                :validation-messages="{
                                    afterEndTime:`Departure time should be after school or program end time`,
                                }"                            
                            />
                        </b-col>
                        <b-col md="12">
                            <FormulateInput
                                v-if="outboundDays ? outboundDays.indexOf('Other') > -1 : false"
                                name="outboufndOther"
                                label="Please describe your outbound transportation routine here."
                            />
                        </b-col>
                        <b-col md="12" class="mt-3">
                            <FormulateInput
                                type="checkbox"
                                name="diffDropoffAddress"
                                label="Check here if the drop-off address (school/facility to home) different from the home address."
                            />
                            <student-address 
                                name="newDropoffAddress" 
                                label="New Drop-off Address" v-if="this.formValues[0] && this.formValues[0].diffDropoffAddress" />
                        </b-col>
                        <b-col md="12" class="mt-3">
                            <FormulateInput
                                type="textarea"
                                name="outboundInfo"
                                label="Specific Pickup Information for OUTbound Route (FROM school/facility)"
                                help="e.g. PICKUP DOOR at school/facility."
                            />
                        </b-col>
                    </b-row>
                    <b-row class="mt-4">
                        <b-col md="6" class="mt-3">
                            <FormulateInput
                                type="checkbox"
                                name="specialNeeds"
                                label="Equipment and Special Needs"
                                :options="specialNeeds"
                            />
                        </b-col>
                        <b-col md="6" class="mt-3">
                            <FormulateInput
                                type="radio"
                                name="studentRelease"
                                label="Student Release"
                                validation="required"
                                validation-name="Release approach"
                                :options="studentRelease"
                            />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <FormulateInput
                                v-if="isAideChecked()"
                                type="checkbox"
                                name="aideOnetoOne"
                                :change="updateAdie()"
                                label="Does this aide need to be assigned only to 1 student if there are multiple students requiring aides?"
                            />
                            <FormulateInput type="hidden" name="aide" />
                        </b-col>
                    </b-row>
                    <b-row class="mt-4">
                        <b-col md="12" class="mt-3">
                            <FormulateInput
                                type="textarea"
                                name="additionalInfo"
                                label="Additional transportation instructions"
                            />
                        </b-col>
                    </b-row>
                </b-form-group>                          
            </FormulateInput>
        </b-form>
      <p></p>
    </div>
</template>
<script>
import StudentAddress from './StudentAddress.vue';  
import { getBuilding } from '../services/api.js';
import DropdownLists from './DropdownLists.json'

    export default {
	components: {StudentAddress},
        name: "TransDetails",
        props: {
          defaultValue: [],
        },
        data() {  
            return {
                inboundDays: [],
                outboundDays: [],
                startDate: '',
                startTime:"",
                arrivalTime: "",
                schoolEndTime:"",
                departureTime: "",
                allInDaysSelected: false,
                allOutDaysSelected: false,
                formValues: {},
                schoolList: [],
                weekDays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Other'],
                selectedSchool: "",
                schoolCode: "",
                schoolName: "",
                schoolAddress: [{
                    "addressLabel": "school Address", 
                    "street": "", 
                    "city": "", 
                    "state": "", 
                    "zip_code": ""
                }],
                today() {
                    var today = new Date();
                    var month = today.getMonth() + Number(1);
                    if (month < 10) {
                        month = '0'+month;
                    }
                    var date = today.getDate();
                    if (date < 10) {
                        date = '0'+date;
                    }
                    return today.getFullYear() +'-'+ month +'-'+ date
                },
                specialNeeds: DropdownLists.specialNeeds,
                studentRelease: DropdownLists.studentRelease,
                aides: DropdownLists.Aides,
            };
        },
        methods: {
            checkInboundSelectAll(){
                if (this.inboundDays) {
                    let b = this.inboundDays.slice(0,5)
                    let a = this.weekDays.slice(0,5)
                    // checking if each value of a is strictly equal to the corresponding value of 
                    if (a.every((val, index) => val === b[index])){
                        this.allInDaysSelected = true;
                    } else {
                        this.allInDaysSelected = false;
                    }
                }
            },
            checkOutboundSelectAll(){
                if (this.outboundDays) {
                    let b = this.outboundDays.slice(0,5)
                    let a = this.weekDays.slice(0,5)
                    if (a.every((val, index) => val === b[index])){                        
                        this.allOutDaysSelected = true;
                    } else {
                        this.allOutDaysSelected = false;
                    }
                }
            },
            toggleAllInbound(checked) {
                this.inboundDays = checked ? this.weekDays.slice(0, 5) : []
            },
            toggleAllOutbound(checked) {
                this.outboundDays = checked ? this.weekDays.slice(0, 5) : []
            },
            minutesOff(bound, minutes=-5) {
                var baseTime;
                var resultTime;
                baseTime = (bound === 'inbound') ? baseTime = this.startTime : baseTime = this.schoolEndTime;
                if (baseTime){
                    var date = new Date();
                    var HH = baseTime.substring(0,2);
                    var MM = Number(baseTime.substring(3,5)) + minutes;
                    date.setHours(HH, MM);
                    var newHH = date.getHours() < 10 ? '0'+date.getHours() : date.getHours()
                    var newMM = date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()
                    resultTime = newHH +':'+ newMM
                } else{
                    resultTime =  '';
                }
                if (bound === 'inbound') {
                    this.arrivalTime = resultTime
                } else{
                    this.departureTime = resultTime;
                }
            },
            getUnixTime(baseTime) {
                if (baseTime){
                    var date = new Date();
                    var HH = baseTime.substring(0,2);
                    var MM = Number(baseTime.substring(3,5));
                    date.setHours(HH, MM);
                    return date.getTime()
                } else{
                    return '';
                }
            },
            setSchool() {
                this.schoolName = this.selectedSchool?.name
                this.schoolCode = this.selectedSchool?.code
                this.schoolAddress[0].street = this.selectedSchool?.address?.street
                this.schoolAddress[0].city = this.selectedSchool?.address?.city
                this.schoolAddress[0].state = this.selectedSchool?.address?.state
                this.schoolAddress[0].zip_code = this.selectedSchool?.address?.zip_code
            },
            isBetweenSummer() {
                let month = new Date(this.formValues[0]?.startDate).getMonth()
                return (month >= 5 && month <= 6)
            },
            isAideChecked() {
                if (this.formValues[0]?.specialNeeds) {
                    if (this.formValues[0]?.specialNeeds.includes("infoAide")) {
                        return this.formValues[0]?.specialNeeds.includes("infoAide")
                    }
                    else {
                        this.formValues[0].aide = ''
                        return false
                    }
                }
                return false
            },
            updateAdie() {
                this.formValues[0].aide = this.formValues[0].aideOnetoOne ? "A1:1" : 'A'
            },
            setDefaultTransDetails () {
                this.formValues =  this.defaultValue ? this.defaultValue : ''

                this.selectedSchool = this.defaultValue[0]['school']
                this.setSchool()
                delete this.formValues[0]['school']
                this.startTime = this.formValues[0]['startTime']
                this.schoolEndTime = this.formValues[0]['schoolEndTime']
                this.arrivalTime = this.formValues[0]['arrivalTime']
                this.departureTime = this.formValues[0]['departureTime']
                this.formValues[0].diffPickupAddress = false
                this.formValues[0].diffDropoffAddress = false
                this.formValues[0].endDate = null
            },
        },
        mounted() {
            getBuilding()
                .then(result => result.data)
                .then(result => {
                  this.schoolList = result
                }, error => {
                    console.error(error);
                });
          this.setDefaultTransDetails ()
        }
    }
</script>